import { render, staticRenderFns } from "./MainListNew.vue?vue&type=template&id=41acf280&scoped=true&"
import script from "./MainListNew.vue?vue&type=script&lang=js&"
export * from "./MainListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41acf280",
  null
  
)

export default component.exports